import { RenderHTML } from '@wix/cc-user-facing-common-components';
import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';

import { RoadmapETAorVotedFilter } from '../../../types';
import { loginWithAnswersSSO } from '../../../utils/login';
import { useStore } from '../../../zustand/stores';

import css from './index.module.scss';

type RoadmapEmptyStateProps = {
  ETAorVotedFilter: RoadmapETAorVotedFilter;
};

export const RoadmapEmptyState: FunctionComponent<RoadmapEmptyStateProps> = ({
  ETAorVotedFilter,
}) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { user } = useStore((state) => state.userSlice);

  return (
    <Box
      direction="vertical"
      verticalAlign="top"
      className={`${css.emptyState} ${css.roadmapV2}`}
      align="center"
    >
      {ETAorVotedFilter === RoadmapETAorVotedFilter.FOLLOWING ? (
        <>
          <Text
            className={css.emptyStateHeader}
            type="H5"
            weight="bold"
            size="medium"
          >
            {user !== null ? (
              t('roadmap.empty-state.following.header')
            ) : (
              <TextButton
                onClick={
                  locale
                    ? () => loginWithAnswersSSO(location.href, locale)
                    : undefined
                }
                underline="always"
                size="medium"
                className={css.loginButton}
              >
                {t('roadmap.article-list.empty-state.log-in')}
              </TextButton>
            )}
            {user === null && t('roadmap.empty-state.following.log-in.header')}
          </Text>
          <Text className={css.emptyStateSubHeaderFirstRow} size="medium">
            <RenderHTML
              html={
                user !== null
                  ? t('roadmap.empty-state-sub-header.following.first-row')
                  : t(
                      'roadmap.empty-state-sub-header.following.first-row.log-in'
                    )
              }
            />
          </Text>
        </>
      ) : (
        <>
          <Text
            className={css.emptyStateHeader}
            type="H5"
            weight="bold"
            size="medium"
          >
            {t('roadmap.empty-state-header.v2')}
          </Text>
          <Text className={css.emptyStateSubHeaderFirstRow} size="medium">
            {t('roadmap.empty-state-sub-header.first-row.v2')}
          </Text>
        </>
      )}
    </Box>
  );
};
